import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Icon } from '@aqarmap/aqarmap-ui';
import { LabelTypesEnum } from '~myAccount/enums';
import LayoutSkeleton from '~/components/LayoutSkeleton';
import { useGetUserQuery } from '~/redux/api/userApiSlice';
import { PreviewCardProps } from '~/components/PreviewCard/types';

const PreviewCard = ({
  description,
  title,
  whatsappAvailable,
  labelType,
  href,
  img,
  isSubAccount,
  titleAction,
}: PreviewCardProps) => {
  const { isLoading } = useGetUserQuery();
  const { t } = useTranslation('app');

  const hideEditBtn = (labelType: LabelTypesEnum) => {
    switch (labelType) {
      case LabelTypesEnum.COMPANY_DESCRIPTION:
        return false;
      case LabelTypesEnum.PERSONAL_INFO:
        return false;

      default:
        return true;
    }
  };
  return (
    <div
      className={`flex items-start justify-between w-full ${labelType !== LabelTypesEnum.COMPANY_LOGO ? 'border-b last-of-type:border-none border-gray ' : 'pb-x'} py-2x first-of-type:pt-0 last-of-type:pb-0  px-3x`}
    >
      <div className="w-full">
        <div className="flex gap-2x items-center">
          {img}
          {isLoading ? (
            <LayoutSkeleton />
          ) : (
            <div className="flex flex-col gap-x w-full -cn">
              {title && (
                <div className="flex gap-1.5x items-center	">
                  <p className="text-title-5  block">{title}</p>
                  {titleAction}
                </div>
              )}
              {description && (
                <p className="text-body_2 text-gray__dark_1 break-words md:max-w-[500px]">
                  {description}
                </p>
              )}
            </div>
          )}
        </div>
        {whatsappAvailable && (
          <p className="text-body_2 text-gray__dark_1 font-normal mt-x">
            {t('whatsappAvailable')}
          </p>
        )}
      </div>
      {hideEditBtn(labelType) &&
        (isSubAccount ? (
          <button type="button" disabled={true}>
            <Icon name="edit" className="text-gray" />
          </button>
        ) : (
          <Link to={href as string}>
            <Icon name="edit" className="text-blue" />
          </Link>
        ))}
    </div>
  );
};

export default PreviewCard;
